import { Link } from "react-router-dom";

export default function RecruitFloatingCta() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-t border-gray-200 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]">
      <div className="w-full px-4 py-3 md:py-4 flex items-center justify-center">
        <Link
          to="/contact"
          className="w-full md:w-auto bg-[#E47911] text-white font-bold text-base md:text-lg px-8 py-4 md:py-3 rounded-lg transition-all duration-300 hover:bg-[#E47911]/90 hover:-translate-y-0.5 flex items-center justify-center gap-2 whitespace-nowrap"
        >
          <span className="w-6 h-6 flex items-center justify-center">
            <i className="ri-send-plane-line"></i>
          </span>
          今すぐ応募する
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </span>
        </Link>
      </div>
    </div>
  );
}